import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App} from 'antd';
import {  useKehulxUpdateSaveMutation, } from '../../store/DianShangYeWuApi';
function ClientTypeEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        'khlx_qy_id': props.qy_id,
        'khlx_qy_name': props.qy_name,
        'khlx_name': props.khlx_name,
        'khlx_cid': props.yh_id,
        'khlx_cname': props.yh_name,        
        'khlx_id': props.khlx_id,
        'khlx_update_uname': props.yh_name,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                khlx_name:props.khlx_name, 
            })   
        }
    },[open ,props])
    const [goodsEdit] = useKehulxUpdateSaveMutation()    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.khlx_name}</a>
            <Modal
                open={open}
                title='修改客户类型'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            goodsEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >                    
                    <Form.Item name="khlx_name" wrapperCol={{span:10}} required label='客户类型'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,khlx_name:e.target.value}))
                        }}/>
                    </Form.Item>                                                      
                    <Form.Item  wrapperCol={{span:10}} label='新增记录'>                        
                        {props.khlx_ctime} {props.khlx_cname}
                    </Form.Item>
                    <Form.Item  wrapperCol={{span:10}} label='修改记录'>                        
                        {props.khlx_update_time} {props.khlx_update_uname}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientTypeEdit